import React from "react";
import MessengerCustomerChat from "react-messenger-customer-chat";
import { connect } from "react-redux";

class ChatBot extends React.Component {
  render() {
    const lang = this.props.langBase.abbr;
    return (
      <div style={{ position: "absolute", bottom: 0, right: 0 }}>
        <MessengerCustomerChat
          language={lang}
          pageId="1764910123778953"
          appId="794118760967893"
          greetingDialogDisplay={"fade"}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  langBase: state.langBase
});

export default connect(mapStateToProps)(ChatBot);
